<template>
  <div v-if="offersStore && offersStore.length">
    <template v-if="!isIndividual && !isVeryFirstState">
      <p v-html="getStepText('firstParagrapheWaiting')"></p>
      <p v-html="getStepText('secondParagrapheWaiting')"></p>
    </template>
    <template v-else>
      <p v-html="getStepText('firstParagraphe')"></p>
      <p v-html="getStepText('secondParagraphe')"></p>
    </template>
    <p v-if="isMinarm" v-html="getStepText('thirdParagraphe')"></p>
    <template v-if="isIndividual || isVeryFirstState">
      <el-button
        @click="$router.push({ name: 'comparator' })"
        class="el-button el-button--success"
        type="success">
        {{ $t('procedures.steps.first.toSeeComparator') }}
      </el-button>
    </template>
  </div>
  <div v-else>
    <p>{{ getStepText('firstParagrapheNoOffers') }}</p>
  </div>
</template>

<script>
import StepWrapper from '@/components/procedures/prebookStepper/steps/StepWrapper.vue';

export default {
  name: 'step1',
  extends: StepWrapper,
};
</script>
